import React from 'react'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'

interface ServicesHeaderProps {
  onAddService: () => void
}

export function ServicesHeader({ onAddService }: ServicesHeaderProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Services Management</h1>
        <p className="text-muted-foreground">
          Manage your masonry services with SEO optimization and content management.
        </p>
      </div>
      <div className="flex gap-2">
        <Button onClick={onAddService}>
          <Plus className="mr-2 h-4 w-4" />
          Add Service
        </Button>
      </div>
    </div>
  )
}
